/**
 * Display labels for upstream location codes.
 *
 * The backend pool stores an opaque location CODE per upstream (e.g. `ORD`),
 * mirrored from the portal's switch enum. This map turns those codes into
 * customer-friendly city labels for the endpoint builder's location picker.
 * It's presentation-only reference data — the source of truth for which
 * locations actually exist is the live pool (see `listAvailableLocations`), so
 * an unmapped code falls back to showing the code verbatim rather than hiding.
 */
export const LOCATION_LABELS: Record<string, string> = {
  SAN: 'San Diego, CA',
  PHX: 'Phoenix, AZ',
  MKE: 'Milwaukee, WI',
  DFW: 'Dallas-Fort Worth, TX',
  NYC: 'New York, NY',
  LAX: 'Los Angeles, CA',
  SEA: 'Seattle, WA',
  MIA: 'Miami, FL',
  PHL: 'Philadelphia, PA',
  DEN: 'Denver, CO',
  HOU: 'Houston, TX',
  BNA: 'Nashville, TN',
  BUF: 'Buffalo, NY',
  CLT: 'Charlotte, NC',
  DTW: 'Detroit, MI',
  ATL: 'Atlanta, GA',
  ORF: 'Norfolk, VA',
  CMH: 'Columbus, OH',
  IND: 'Indianapolis, IN',
  BHM: 'Birmingham, AL',
  SAT: 'San Antonio, TX',
  SJC: 'San Jose, CA',
  PDX: 'Portland, OR',
  LAS: 'Las Vegas, NV',
  JAX: 'Jacksonville, FL',
  STL: 'St. Louis, MO',
  MCI: 'Kansas City, KS',
  HNL: 'Honolulu, HI',
  SLC: 'Salt Lake City, UT',
  ABQ: 'Albuquerque, NM',
  IDA: 'Idaho Falls, ID',
  BDL: 'Hartford, CT',
  HSV: 'Huntsville, AL',
  BOS: 'Boston, MA',
  MSP: 'Minneapolis, MN',
  BWI: 'Baltimore, MD',
  EWR: 'Newark, NJ',
  PWM: 'Portland, ME',
  OMA: 'Omaha, NE',
  SHV: 'Shreveport, LA',
  BIL: 'Billings, MT',
  LIT: 'Littlerock, AR',
  JAN: 'Jackson, MS',
  DSM: 'Des Moines, IA',
  ORD: 'Chicago, IL',
  RIC: 'Richmond, VA',
}

/** Human label for a location code, falling back to the raw code if unmapped. */
export function locationLabel(code: string): string {
  return LOCATION_LABELS[code] ?? code
}
